// Gerado automaticamente por scripts/generate-version.js — não editar manualmente.
export const APP_VERSION = "V1.1.0.261104";
export const APP_BUILD_TIME = "2026-11-04T01:04:10.463Z";
